/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DynamicFormConstraintOption { 
    /** @deprecated */
    constraintId?: string;
    data?: string;
    action?: DynamicFormConstraintOption.ActionEnum;
    trigger?: string;
}
export namespace DynamicFormConstraintOption {
    export const ActionEnum = {
        Show: 'SHOW',
        Hide: 'HIDE',
        Populate: 'POPULATE',
        Clear: 'CLEAR',
        Enable: 'ENABLE',
        Disable: 'DISABLE',
        Prepopulate: 'PREPOPULATE',
        PreloadPotentialAnswers: 'PRELOAD_POTENTIAL_ANSWERS'
    } as const;
    export type ActionEnum = typeof ActionEnum[keyof typeof ActionEnum];
}


